let dict = {
  Gascon: 'Gascón',
};

/**
 * Gets the last name from the dictionary.
 * @param {string} name The name to get from the dictionary.
 */
export default function lastNameDict(name) {
  return name in dict ? dict[name] : name;
}
